module.exports = __webpack_public_path__ + "static/media/mentions.81f744d8.jpg";